(() => {
  if (window.__awExactModelGateLoaded) return;
  window.__awExactModelGateLoaded = true;

  const norm = (v = '') => String(v).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const split = (v = '') => String(v).split(',').map(norm).filter(Boolean);

  const lockCard = (card, badgeText, conflict = false) => {
    const box = card.querySelector('[data-aw-product-checkbox]');
    const selector = box?.closest('.aw-compatible-card__selector');
    const quick = card.querySelector('[data-aw-quick-add]');
    const badge = card.querySelector('[data-aw-card-badge]');
    card.dataset.awEligible = 'false';
    if (conflict) card.dataset.awTechnicalConflict = 'true';
    if (box) { box.checked = false; box.disabled = true; }
    if (selector) selector.hidden = true;
    if (quick) { quick.disabled = true; quick.hidden = true; }
    if (badge) badge.textContent = badgeText;
  };

  const apply = (scope = document) => {
    scope.querySelectorAll?.('[data-aw-compatible-products]').forEach((root) => {
      const current = new Set(split(root.dataset.currentModels || ''));
      if (!current.size) return;

      root.querySelectorAll('[data-aw-product-card]').forEach((card) => {
        const relationModels = split(card.dataset.awRelationModels || '');

        if (!relationModels.length) {
          card.dataset.awExactModelProof = 'missing';
          card.dataset.awExactModelUnproven = 'true';
          lockCard(card, 'À vérifier — aucune preuve pour le modèle exact sélectionné');
          return;
        }

        const overlap = relationModels.some((handle) => current.has(handle));
        if (overlap) {
          card.dataset.awExactModelProof = 'matched';
          card.dataset.awExactModelUnproven = 'false';
          return;
        }

        card.dataset.awExactModelProof = 'mismatch';
        card.dataset.awExactModelUnproven = 'false';
        lockCard(card, 'Incompatible avec le modèle exact sélectionné', true);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const action = event.target.closest?.('[data-aw-quick-add], [data-aw-product-checkbox]');
    const card = action?.closest?.('[data-aw-product-card]');
    if (card?.dataset.awTechnicalConflict === 'true' || card?.dataset.awExactModelUnproven === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes?.length)) requestAnimationFrame(() => apply(document));
  });

  const start = () => {
    apply(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();